import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map_open",
  "use": "icon-map_open-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-map_open\">\n<g id=\"icon-map_open_surface1\">\n<path style=\" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;\" d=\"M 0 0 C 4.347656 9.320313 11.652344 9.320313 16 0 C 8 3.609375 7.863281 3.609375 0 0 M 0 7 C 4.347656 16.320313 11.652344 16.320313 16 7 C 8 10.609375 7.863281 10.609375 0 7 \" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/map/map_open.svg
// module id = LF8/
// module chunks = 24